import React, { useState } from 'react';
import { UserManagement } from '../UserManagement/UserManagement';
import { UserGroupSettings } from '../UserGroups';
import { TeamInvitations } from '../TeamInvitations';
import { TeamSettings } from '../TeamSettings/TeamSettings';
import { Typography } from 'interfaces/typography';

enum TeamTabs {
  USERS = 'Users',
  SUBTEAMS = 'Subteams',
  INVITES = 'Invites',
  SETTINGS = 'Team Settings'
}

export function TeamManagement() {
  const [activeTab, setActiveTab] = useState<TeamTabs>(TeamTabs.USERS);

  const renderTabButton = (tab: TeamTabs) => (
    <button
      key={tab}
      onClick={() => setActiveTab(tab)}
      className={`px-4 py-2 border-b-2 transition-colors duration-200 ${
        activeTab === tab
          ? 'border-blue-600'
          : 'border-transparent hover:border-gray-300'
      }`}
    >
      <Typography
        variant="mediumParagraph"
        color={activeTab === tab ? '#2563eb' : '#6b7280'}
        fontWeight={500}
      >
        {tab}
      </Typography>
    </button>
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case TeamTabs.USERS:
        return <UserManagement />;
      case TeamTabs.SUBTEAMS:
        return <UserGroupSettings />;
      case TeamTabs.INVITES:
        return <TeamInvitations />;
      case TeamTabs.SETTINGS:
        return <TeamSettings />;
      default:
        return <UserManagement />;
    }
  };

  return (
    <div className="h-full flex flex-col">
      {/* Header with title and tabs */}
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="mb-4">
          <Typography variant="h2" color="#1F2937" fontWeight={600}>
            Team Management
          </Typography>
          <Typography variant="smallParagraph" color="#6B7280" style={{ marginTop: '0.25rem' }}>
            Manage your team members, subteams, and invitations
          </Typography>
        </div>

        {/* Tab Navigation */}
        <div className="flex space-x-6 border-b border-gray-200">
          {Object.values(TeamTabs).map(tab => renderTabButton(tab))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-auto">
        {renderTabContent()}
      </div>
    </div>
  );
}